import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { MapPin } from "lucide-react";

/** Cidade com busca automática (municípios do IBGE): ao escolher, preenche também a UF. */
export function CityInput({ value, onChange, onPick, placeholder = "Digite a cidade", testid }) {
  const [opts, setOpts] = useState([]);
  const [open, setOpen] = useState(false);
  const [i, setI] = useState(-1);
  const box = useRef(null);
  const typed = useRef(false);
  useEffect(() => {
    if (!typed.current || (value || "").trim().length < 2) { setOpts([]); return undefined; }
    const t = setTimeout(() => api.get("/admin/cities", { params: { q: value } }).then((r) => { setOpts(r.data); setOpen(true); setI(-1); }).catch(() => setOpts([])), 250);
    return () => clearTimeout(t);
  }, [value]);
  useEffect(() => {
    const f = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", f); return () => document.removeEventListener("mousedown", f);
  }, []);
  const pick = (o) => { typed.current = false; onPick(o); setOpen(false); setOpts([]); };
  return (
    <div ref={box} className="relative">
      <Input value={value} placeholder={placeholder} autoComplete="off" data-testid={testid}
        onChange={(e) => { typed.current = true; onChange(e.target.value); }}
        onFocus={() => opts.length && setOpen(true)}
        onKeyDown={(e) => {
          if (!open || !opts.length) return;
          if (e.key === "ArrowDown") { e.preventDefault(); setI((x) => Math.min(x + 1, opts.length - 1)); }
          if (e.key === "ArrowUp") { e.preventDefault(); setI((x) => Math.max(x - 1, 0)); }
          if (e.key === "Enter" && i >= 0) { e.preventDefault(); pick(opts[i]); }
          if (e.key === "Escape") setOpen(false);
        }} />
      {open && opts.length > 0 && (
        <div className="absolute z-50 mt-1 w-full max-h-64 overflow-y-auto rounded-lg border border-slate-200 bg-white shadow-lg" data-testid="city-options">
          {opts.map((o, k) => (
            <button key={`${o.city}-${o.state}`} type="button" onMouseDown={(e) => { e.preventDefault(); pick(o); }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-left text-sm ${k === i ? "bg-green-50" : "hover:bg-slate-50"}`}>
              <MapPin className="h-3.5 w-3.5 text-slate-400" /> <span className="flex-1">{o.city}</span> <span className="text-xs font-semibold text-slate-500">{o.state}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
